import * as types from '../mutation-types'
import { setItemStorage, getItemStorage } from '../../plugins/util'
import * as constants from '../../mixins/constants'
import { logEvent } from '../../mixins/analytic-tracking'
import { EVENTS, ACTIONS } from '../../mixins/tracking-events'
import moment from 'moment'

const { filter, find } = require('@/plugins/lodash')

const state = {
  messageList: [],
  activeMessage: null,
  todayMessages: []
}

const todayKey = moment().format('YYYYMMDD')

// getters
const getters = {
  messages: (state) => state.messageList,
  message: (state) => state.activeMessage,
  todayMessages: (state) => state.todayMessages,
  unreadMessages: (state) => {
    return filter(state.todayMessages, { read: false })
  }
}

// actions
const actions = {
  setMessages({ commit }, orders) {
    commit(types.SET_MESSAGES, orders)
  },
  setActiveMessage: ({ commit }, value) => {
    commit(types.SET_ACTIVE_MESSAGE, value)
  },
  putMessage: ({ commit }, value) => {
    commit(types.PUT_MESSAGE, value)
  },
  setTodayMessage: ({ commit }, value) => {
    commit(types.SET_TODAY_MESSAGES, value)
  },
  readMessage: ({ commit }, value) => {
    commit(types.SET_READ_MESSAGE, value)
  },
  resetMessages: ({ commit }) => {
    commit(types.RESET_MESSAGES)
  }
}

// mutations
const mutations = {
  [types.PUT_MESSAGE](state, message) {
    state.messageList.unshift(message)
    state.todayMessages.push({
      _id: 'in_notify_modal',
      read: true
    })
    setItemStorage(
      constants.LOCAL_STORAGE_KEY__MESSAGES,
      JSON.stringify({ [todayKey]: state.todayMessages })
    )
  },
  [types.SET_MESSAGES](state, messages) {
    state.messageList.push(...messages)
  },
  [types.RESET_MESSAGES](state) {
    state.messageList = []
  },
  [types.SET_ACTIVE_MESSAGE](state, value) {
    state.activeMessage = value
    if (value) {
      logEvent(ACTIONS.NON_INTERACTION, EVENTS.NOTIFICATION_CLICK_ITEM_SHOW, {}, undefined, {
        _id: value._id,
        title: value.title
      })
    }
  },
  [types.SET_READ_MESSAGE](state, message) {
    const readMsg = find(state.todayMessages, { _id: message.time })
    if (readMsg) readMsg.read = true
    setItemStorage(
      constants.LOCAL_STORAGE_KEY__MESSAGES,
      JSON.stringify({ [todayKey]: state.todayMessages })
    )
  },
  [types.SET_TODAY_MESSAGES](state, messages) {
    const todayMsg = filter(messages, (message) => {
      return moment.unix(message.time).format('YYYYMMDD') === todayKey
    })
    const cachedData = getItemStorage(constants.LOCAL_STORAGE_KEY__MESSAGES)
    if (cachedData) {
      const messagesObj = JSON.parse(cachedData)
      state.todayMessages = messagesObj[todayKey] || []
      if (messagesObj[todayKey] && messagesObj[todayKey].length === todayMsg.length) {
        return
      }
    }

    todayMsg.forEach((item) => {
      const isCached = find(state.todayMessages, { _id: item.time })
      if (!isCached) {
        state.todayMessages.push({
          _id: item.time,
          read: false
        })
      }
    })
    setItemStorage(
      constants.LOCAL_STORAGE_KEY__MESSAGES,
      JSON.stringify({ [todayKey]: state.todayMessages })
    )
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
